<template>
    <v-app>
        <v-main>
            <v-container class="ml-auto" style="max-width: 960px">
                <router-view />
            </v-container>
        </v-main>
        <v-snackbars
            :snackbars="snackbars"
            @close="removeTopSnackbar"
            label-close="Sluiten"
            label-next="Volgende"
        ></v-snackbars>
    </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import VSnackbars from '@/components/VSnackbars';

export default {
    name: 'App',
    components: {
        VSnackbars,
    },
    data: () => ({

    }),
    computed: {
        ...mapGetters(['snackbars']),
    },
    methods: {
        ...mapActions(['removeTopSnackbar']),
    },
    created() {
        let html = document.documentElement // returns the html tag
        html.setAttribute('lang', 'nl')
    }
};
</script>
